import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

export interface Premier {
  id: string
  type: string
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

const premieres = ({ page = 1, perPage = 8, search = '' }) => {
  return api
    .get<{ data: Premier[]; total: number }>('/courses/premieres', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) => ({
      courses: data.data.map((premier) => premier.attributes),
      total: data.total,
    }))
}

export default premieres
